import React from 'react';
import {IonButton, IonCol, IonContent, IonFooter, IonPage, IonRow, IonToolbar, useIonAlert} from "@ionic/react";
import {actionToPermanentlyAccountDeletion} from "../apiHelpers/CommonAction";

export default function DeactivateAccountPage({withoutLogin,renderHeaderPage}) {
    const [presentAlert] = useIonAlert();
    const handleAccountDeletion = ()=>{
        presentAlert({
            header: 'Confirm Account Deactivation',
            cssClass:"confirm_alert_custom",
            message: 'Are you sure you want to permanently delete your account?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                },
                {
                    text: 'Yes',
                    handler: () => {
                        actionToPermanentlyAccountDeletion();
                    },
                },
            ],
        });
    }

    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent fullscreen className="common-content page-content">
                <div className="desktop-contain-aboutus">
                    <IonRow>
                        <IonCol size="12" sizeMd="9" className="text-left">
                            <h1 className="m-0 p-heading">Deactivate Account</h1>

                            <h4 className="s-heading-r">1. What Happens When You Deactivate</h4>
                            <p className="text-left l-height-24 fw-400">
                                Once you choose to deactivate your CA World App account, all your personal information, login credentials,
                                and activity data will be permanently deleted from our systems. This includes your profile, membership details,
                                saved preferences, and any other data linked to your account.
                            </p>

                            <h4 className="s-heading-r">2. Irreversible Action</h4>
                            <p className="text-left l-height-24 fw-400">
                                Account deactivation is <b>permanent and cannot be undone</b>. Once deleted, your data cannot be recovered or restored.
                                You will need to create a new account to access CA World App again in the future.
                            </p>

                            <h4 className="s-heading-r">3. Data Deletion Process</h4>
                            <ul>
                                <li>All personal and account data is deleted from active systems immediately upon confirmation.</li>
                                <li>Backup data (if any) will be purged during our regular backup deletion cycle within 30 days.</li>
                                <li>We retain minimal data only if required by law or regulatory compliance.</li>
                            </ul>

                            <h4 className="s-heading-r">4. Before You Proceed</h4>
                            <ul>
                                <li>Ensure you have downloaded any important data or documents linked to your account.</li>
                                <li>Pending transactions or subscriptions will be automatically canceled.</li>
                                <li>Access to premium or member-only features will be terminated.</li>
                            </ul>

                            <h4 className="s-heading-r">5. How to Deactivate Your Account</h4>
                            <p className="text-left l-height-24 fw-400">
                                You can deactivate your account by contacting our support team:
                            </p>
                            <ul>
                                <li>📧 <b>Email:</b> support@caworld.com</li>
                                <li>📞 <b>Phone:</b> +91 9711310004</li>
                                <li>📍 <b>Address:</b> 4696 Brij Bhawan, 21A Ansari Road, Daryaganj, New Delhi – 110002</li>
                            </ul>

                            <h4 className="s-heading-r">6. Confirmation</h4>
                            <p className="text-left l-height-24 fw-400">
                                After verifying your identity, we will process your request and send you an email confirmation once your account
                                and related data are deleted.
                            </p>

                            <h4 className="s-heading-r">7. Rejoining</h4>
                            <p className="text-left l-height-24 fw-400">
                                You are always welcome to rejoin the CA World community by signing up again as a new user after deactivation.
                            </p>
                        </IonCol>
                    </IonRow>
                </div>
            </IonContent>
            {(!withoutLogin) ?
            <IonFooter className="ion-paddingblank_footer_bar">
                <IonToolbar>
                    <IonRow>
                        <IonCol>
                            <IonButton
                                expand="block"
                                className="apply_job_button"
                                onClick={handleAccountDeletion}
                            >
                                Delete Account Permanently
                            </IonButton>
                        </IonCol>
                    </IonRow>
                </IonToolbar>
            </IonFooter>:''
            }
        </IonPage>
    );
}
